import { Box } from '@zillow/constellation-10';
import { LeasesCard, PropertyConditionCard, RentersInsuranceCard } from '../Documents';

const EmptyDocuments = () => {
  return (
    <Box
      css={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: { base: '1fr', md: '1fr', lg: 'repeat(3, 1fr)' },
        gap: 'default',
      }}
      data-testid="Documents"
    >
      <LeasesCard />
      <PropertyConditionCard />
      <RentersInsuranceCard />
    </Box>
  );
};

export default EmptyDocuments;
